import { GET_INSTRUMENT_FAMILIES } from "constants/instrumentFamilies";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_INSTRUMENT_FAMILIES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
